import { World } from "../../contexts/AppContext";

export default {
  [World["CoralLagoon"]]: {
    src: new URL(
      "./Loading-Screen-Desktop-CL.jpg?as=jpg",
      import.meta.url
    ) as any as string,
    srcSetLandscape: {
      webp: `${
        new URL(
          "./Loading-Screen-Desktop-CL.jpg?as=webp&width=2200?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 2200w,${
        new URL(
          "./Loading-Screen-Desktop-CL.jpg?as=webp&width=1800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1800w,${
        new URL(
          "./Loading-Screen-Desktop-CL.jpg?as=webp&width=1400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1400w,${
        new URL(
          "./Loading-Screen-Desktop-CL.jpg?as=webp&width=1000?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1000w,${
        new URL(
          "./Loading-Screen-Desktop-CL.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,`,
      jpg: `${
        new URL(
          "./Loading-Screen-Desktop-CL.jpg?as=jpg&width=2200?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 2200w,${
        new URL(
          "./Loading-Screen-Desktop-CL.jpg?as=jpg&width=1800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1800w,${
        new URL(
          "./Loading-Screen-Desktop-CL.jpg?as=jpg&width=1400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1400w,${
        new URL(
          "./Loading-Screen-Desktop-CL.jpg?as=jpg&width=1000?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1000w,${
        new URL(
          "./Loading-Screen-Desktop-CL.jpg?as=jpg&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,`,
    },
    srcSetPortrait: {
      webp: `${
        new URL(
          "./Loading-Screen-Mobile-CL.jpg?as=webp&width=2200?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 2200w,${
        new URL(
          "./Loading-Screen-Mobile-CL.jpg?as=webp&width=1800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1800w,${
        new URL(
          "./Loading-Screen-Mobile-CL.jpg?as=webp&width=1400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1400w,${
        new URL(
          "./Loading-Screen-Mobile-CL.jpg?as=webp&width=1000?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1000w,${
        new URL(
          "./Loading-Screen-Mobile-CL.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,`,
      jpg: `${
        new URL(
          "./Loading-Screen-Mobile-CL.jpg?as=jpg&width=2200?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 2200w,${
        new URL(
          "./Loading-Screen-Mobile-CL.jpg?as=jpg&width=1800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1800w,${
        new URL(
          "./Loading-Screen-Mobile-CL.jpg?as=jpg&width=1400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1400w,${
        new URL(
          "./Loading-Screen-Mobile-CL.jpg?as=jpg&width=1000?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1000w,${
        new URL(
          "./Loading-Screen-Mobile-CL.jpg?as=jpg&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,`,
    },
  },
  [World["FieldTrip"]]: {
    src: new URL(
      "./Loading-Screen-Desktop-FT.jpg?as=jpg",
      import.meta.url
    ) as any as string,
    srcSetLandscape: {
      webp: `${
        new URL(
          "./Loading-Screen-Desktop-FT.jpg?as=webp&width=2200?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 2200w,${
        new URL(
          "./Loading-Screen-Desktop-FT.jpg?as=webp&width=1800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1800w,${
        new URL(
          "./Loading-Screen-Desktop-FT.jpg?as=webp&width=1400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1400w,${
        new URL(
          "./Loading-Screen-Desktop-FT.jpg?as=webp&width=1000?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1000w,${
        new URL(
          "./Loading-Screen-Desktop-FT.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,`,
      jpg: `${
        new URL(
          "./Loading-Screen-Desktop-FT.jpg?as=jpg&width=2200?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 2200w,${
        new URL(
          "./Loading-Screen-Desktop-FT.jpg?as=jpg&width=1800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1800w,${
        new URL(
          "./Loading-Screen-Desktop-FT.jpg?as=jpg&width=1400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1400w,${
        new URL(
          "./Loading-Screen-Desktop-FT.jpg?as=jpg&width=1000?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1000w,${
        new URL(
          "./Loading-Screen-Desktop-FT.jpg?as=jpg&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,`,
    },
    srcSetPortrait: {
      webp: `${
        new URL(
          "./Loading-Screen-Mobile-FT.jpg?as=webp&width=2200?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 2200w,${
        new URL(
          "./Loading-Screen-Mobile-FT.jpg?as=webp&width=1800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1800w,${
        new URL(
          "./Loading-Screen-Mobile-FT.jpg?as=webp&width=1400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1400w,${
        new URL(
          "./Loading-Screen-Mobile-FT.jpg?as=webp&width=1000?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1000w,${
        new URL(
          "./Loading-Screen-Mobile-FT.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,`,
      jpg: `${
        new URL(
          "./Loading-Screen-Mobile-FT.jpg?as=jpg&width=2200?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 2200w,${
        new URL(
          "./Loading-Screen-Mobile-FT.jpg?as=jpg&width=1800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1800w,${
        new URL(
          "./Loading-Screen-Mobile-FT.jpg?as=jpg&width=1400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1400w,${
        new URL(
          "./Loading-Screen-Mobile-FT.jpg?as=jpg&width=1000?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1000w,${
        new URL(
          "./Loading-Screen-Mobile-FT.jpg?as=jpg&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,`,
    },
  },
  [World["FungiForest"]]: {
    src: new URL(
      "./Loading-Screen-Desktop-FF.jpg?as=jpg",
      import.meta.url
    ) as any as string,
    srcSetLandscape: {
      webp: `${
        new URL(
          "./Loading-Screen-Desktop-FF.jpg?as=webp&width=2200?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 2200w,${
        new URL(
          "./Loading-Screen-Desktop-FF.jpg?as=webp&width=1800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1800w,${
        new URL(
          "./Loading-Screen-Desktop-FF.jpg?as=webp&width=1400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1400w,${
        new URL(
          "./Loading-Screen-Desktop-FF.jpg?as=webp&width=1000?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1000w,${
        new URL(
          "./Loading-Screen-Desktop-FF.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,`,
      jpg: `${
        new URL(
          "./Loading-Screen-Desktop-FF.jpg?as=jpg&width=2200?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 2200w,${
        new URL(
          "./Loading-Screen-Desktop-FF.jpg?as=jpg&width=1800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1800w,${
        new URL(
          "./Loading-Screen-Desktop-FF.jpg?as=jpg&width=1400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1400w,${
        new URL(
          "./Loading-Screen-Desktop-FF.jpg?as=jpg&width=1000?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1000w,${
        new URL(
          "./Loading-Screen-Desktop-FF.jpg?as=jpg&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,`,
    },
    srcSetPortrait: {
      webp: `${
        new URL(
          "./Loading-Screen-Mobile-FF.jpg?as=webp&width=2200?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 2200w,${
        new URL(
          "./Loading-Screen-Mobile-FF.jpg?as=webp&width=1800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1800w,${
        new URL(
          "./Loading-Screen-Mobile-FF.jpg?as=webp&width=1400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1400w,${
        new URL(
          "./Loading-Screen-Mobile-FF.jpg?as=webp&width=1000?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1000w,${
        new URL(
          "./Loading-Screen-Mobile-FF.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,`,
      jpg: `${
        new URL(
          "./Loading-Screen-Mobile-FF.jpg?as=jpg&width=2200?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 2200w,${
        new URL(
          "./Loading-Screen-Mobile-FF.jpg?as=jpg&width=1800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1800w,${
        new URL(
          "./Loading-Screen-Mobile-FF.jpg?as=jpg&width=1400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1400w,${
        new URL(
          "./Loading-Screen-Mobile-FF.jpg?as=jpg&width=1000?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 1000w,${
        new URL(
          "./Loading-Screen-Mobile-FF.jpg?as=jpg&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,`,
    },
  },
};
